import React from "react";

const RightCarretIcon = ({width=20,height=20}) => {
  return (
    <svg width={width} height={height}  cursor="pointer" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.875 0.75L7.125 7L0.875 13.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>      
  );
};

export default RightCarretIcon;
